import React from "react";
import { useParticles } from "../../hooks/useParticles";

const ParticlesBackground: React.FC = () => {
  const canvasRef = useParticles();

  return (
    <>
      {/* Niebla mágica */}
      <div className="magic-fog"></div>

      {/* Partículas en canvas */}
      <canvas ref={canvasRef} className="particles" />

      {/* Orbes mágicos */}
      <div className="magic-orb" style={{ top: "20%", left: "10%" }}></div>
      <div
        className="magic-orb"
        style={{
          top: "70%",
          left: "80%",
          width: "20px",
          height: "20px",
          animationDuration: "20s",
        }}
      ></div>
      <div
        className="magic-orb"
        style={{
          top: "40%",
          left: "90%",
          background: "#5d8aa8",
          boxShadow: "0 0 20px #5d8aa8, 0 0 40px #5d8aa8",
        }}
      ></div>
      <div
        className="magic-orb"
        style={{
          top: "85%",
          left: "15%",
          background: "#9b59b6",
          boxShadow: "0 0 20px #9b59b6, 0 0 40px #9b59b6",
        }}
      ></div>
      <div
        className="magic-orb"
        style={{
          top: "30%",
          left: "70%",
          width: "25px",
          height: "25px",
        }}
      ></div>
    </>
  );
};

export default ParticlesBackground;
